module.exports = __webpack_public_path__ + "img/logo47.83cc2f98.png";